"use client";
import clsx from "clsx";
import {
  Boxes,
  Brush,
  ChevronDown,
  FileBox,
  Image,
  LayoutGrid,
  MessageSquare,
  ShoppingCart,
  Ticket,
  Users,
} from "lucide-react";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const side = [
  {
    title: "Navigation",
    links: [
      { title: "Dashboard", link: "/", icon: LayoutGrid },
      { title: "Banner", link: "/banner", icon: Image },
    ],
  },
  {
    title: "Product Management",
    links: [
      {
        title: "Categories",
        icon: FileBox,
        link: "/categories",
      },
      {
        title: "Products",
        icon: Boxes,
        link: "/products",
      },
      {
        title: "Combos",
        icon: Boxes,
        link: "/combos",
      },
    ],
  },
  {
    title: "Order Management",
    links: [
      {
        title: "Orders",
        icon: ShoppingCart,
        link: "/orders",
      },
      {
        title: "Returns",
        icon: ShoppingCart,
        link: "/returns",
      },
    ],
  },
  {
    title: "User Management",
    links: [
      {
        title: "Users",
        icon: Users,
        link: "/admin/users",
      },
    ],
  },
  {
    title: "Coupons",
    links: [
      {
        title: "Coupons",
        icon: Ticket,
        link: "/coupons",
      },
    ],
  },
  {
    title: "Sales Management",
    links: [
      {
        title: "Sales",
        icon: ShoppingCart,
        link: "/sales",
      },
    ],
  },
  {
    title: "Contact Management",
    links: [
      {
        title: "Contacts",
        icon: MessageSquare,
        link: "/admin/contacts",
      },
      {
        title: "Bulk Orders",
        icon: MessageSquare,
        link: "/admin/bulk-orders",
      },
      {
        title: "Customize",
        icon: Brush,
        link: "/admin/customize",
      },
    ],
  },
];

const Sidebar = () => {
  return (
    <aside className="w-[18rem] bg-white shadow-sm sticky top-0 h-screen border-r">
      <div className="p-6 flex flex-col gap-2">
        {side.map((s, index) => (
          <Nav key={index} link={s} index={0} />
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;

const Nav = ({ link, index }) => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  return (
    <div className="flex flex-col gap-3">
      {index === 0 ? (
        <div>
          <p className="font-bold my-3 uppercase text-xs text-gray-500 ">
            {link?.title}
          </p>
          {link?.links?.map((l, i) => (
            <Nav key={i} link={l} index={index + 1} />
          ))}
        </div>
      ) : link?.links ? (
        <div key={link.title}>
          <button
            onClick={() => setOpen(!open)}
            className="flex gap-4 rounded-lg text-gray-600 items-center justify-between px-4 py-2 w-full hover:bg-gray-100 transition-colors "
          >
            <div className="flex gap-2 font-semibold text-sm items-center">
              <link.icon size={16} />
              {link.title}
            </div>
            <ChevronDown size={16} />
          </button>
          {open && (
            <div>
              {link?.links?.map((l, i) => (
                <Nav key={i} link={l} index={index + 1} />
              ))}
            </div>
          )}
        </div>
      ) : (
        <Link
          to={link.link}
          key={link.title}
          className={clsx(
            "flex gap-2 font-semibold text-sm px-4 hover:text-black rounded-lg py-2 text-gray-600 items-center hover:bg-gray-100 transition-colors ",
            location.pathname === link.link && "bg-primary text-white"
          )}
        >
          {link.icon && <link.icon size={16} />}
          {link.title}
        </Link>
      )}
    </div>
  );
};
